import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { InlineButtonWithSpinner } from 'components/generic/InlineButton';
import { FindYourNuance, TryItOn } from 'autogen/translation-keys/trans-website-modiface';
import loadModiface from './utilities/loadModiface';

export type ModifaceButton = {
    productId: number;
    productHasVariants: boolean;
    onClickCallback?: () => void;
};

function ModifacePDPButton(props: ModifaceButton) {
    const { productId, productHasVariants, onClickCallback, ...restProps } = props;
    const { t } = useTranslation();
    const openModiface = loadModiface(productId);

    useEffect(() => {
        function handleSplashClick(event): void {
            const { target } = event;
            if (target.closest('.js-modifaceModal')) {
                openModiface('splash');
            }
        }
        document.addEventListener('click', handleSplashClick);

        return (): void => {
            document.removeEventListener('click', handleSplashClick);
        };
    }, []);

    return (
        <InlineButtonWithSpinner
            type="button"
            onClick={async () => {
                await openModiface('pdpButton');
                if (onClickCallback) onClickCallback();
            }}
            {...restProps}
        >
            {productHasVariants ? t(FindYourNuance) : t(TryItOn)}
        </InlineButtonWithSpinner>
    );
}

export default ModifacePDPButton;
